import {RomResultTypes, RomTestTypes, ScanPosition, ScanTypes} from "./weak-entities";
import { Scandata } from "./scandata";
import {Decimal} from "decimal.js";
import {BodyTypes, ScanPurpose} from "./scanSettings";

export interface Scan {
  Id?: string;
  ScanType?: ScanTypes;
  Bias?: Decimal;
  CreatedStamp: Date;
  PatientId: string;
  DoctorId: string;
  ScanData: Scandata[];
  OffsetL?: number;
  OffsetR?: number;
  ScanPosition: ScanPosition;
  ScanPurpose: ScanPurpose;
  BodyType: BodyTypes;
  Invalid: boolean;
}

export class ThermalScanBreakdown {
  Score: Decimal = new Decimal(0);
  ScoreVersion: string = '';
  WhiteCount: number = 0;
  WhiteLocations: string[] = [];
  GreenCount: number = 0;
  GreenLocations: string[] = [];
  BlueCount: number = 0;
  BlueLocations: string[] = [];
  RedCount: number = 0;
  RedLocations: string[] = [];
  NonNormalCount: number = 0;
  NonNormalLocations: string[] = [];
  TotalCount: number = 0;
}

export class EmgScanBreakdown {
  Score: Decimal = new Decimal(0);
  ScoreVersion: string = '';
  YellowCount: number = 0;
  YellowLocations: string[] = [];
  WhiteCount: number = 0;
  WhiteLocations: string[] = [];
  GreenCount: number = 0;
  GreenLocations: string[] = [];
  BlueCount: number = 0;
  BlueLocations: string[] = [];
  RedCount: number = 0;
  RedLocations: string[] = [];
  NonNormalCount: number = 0;
  NonNormalLocations: string[] = [];
  TotalCount: number = 0;
  EnergyScore: Decimal = new Decimal(0);
  PatternScore: Decimal = new Decimal(0);
  SymmetryScore: Decimal = new Decimal(0);
  EnergyBand: Band = Band.NORMAL;
  PatternBand: Band = Band.NORMAL;
  SymmetryBand: Band = Band.NORMAL;
}

export class HrvScanBreakdown {
  Score: Decimal = new Decimal(0);
  ScoreVersion: string = '';
  Aa: Decimal = new Decimal(0);
  Ab: Decimal = new Decimal(0);
  Rest: Decimal = new Decimal(0);
  Zone: number = 1;
  AaRating: string = '';
  AbRating: string = '';
  RestRating: string = '';
  Rating: string = '';
}

export class RomScanBreakdown {
  Score: Decimal = new Decimal(0);
  ScoreVersion: string = '';
}

export class AlgoScanBreakdown {
  Score: Decimal = new Decimal(0);
  ScoreVersion: string = '';
  Asymmetries: Decimal[] = [];
  AsymmetryScore: Decimal = new Decimal(1);
  Impairments: Decimal[] = [];
  ImpairmentScore: Decimal = new Decimal(0);
}

export enum ScanViewType {
  THERMAL_NCM = 1,
  THERMAL_LINE,
  THERMAL_SUMMARY,
  EMG_AMPLITUDE,
  EMG_ASYMMETRY,
  EMG_PATTERN,
  ALGO,
  HRV_RAINBOW,
  HRV_HEART_RATE,
  HRV_PULSE,
  EMG_ENHANCED,
  EMG_LIVE,
  ROM_GRAPH,
  THERMAL_TABLE,
  EMG_TABLE,
  HRV_TABLE,
  ROM_TABLE,
  ALGO_TABLE,
  COMPARATIVE,
  EMPTY,
  THERMAL_DTG,
  THERMAL_NORMATIVE,
  EMG_NORMATIVE,
  HRV_NORMATIVE,
  THERMAL_CERVICAL_NCM,
  THERMAL_CERVICAL_LINE,
  THERMAL_CERVICAL_SUMMARY,
  THERMAL_CERVICAL_DTG,
}

export enum ScanViewBg {
  NONE,
  BLUEMAN,
  MUSCLEMAN
}

export enum Band {
  HYPO = -1,
  NORMAL = 1,
  MILD = 2,
  MODERATE = 3,
  SIGNIFICANT = 4
}

export interface RomScan {
  TestType: RomTestTypes,
  ResultType: RomResultTypes[],
  Norm: number[],
  Result?: number[],
  Impairment?: number[],
  Enabled: boolean,
  Complete: boolean,
  Images?: string[]
}



// WEBPACK FOOTER //
// ./src/model/scan.ts